import { Quaternion as o } from "three";
import { getQuaternion as t } from "../geometry-utils/three/index13.js";
const e = new o();
function m(r, n) {
  return n.applyQuaternion(t(r, e));
}
export {
  m as transformDir
};
//# sourceMappingURL=index33.js.map
